import React from 'react';
import { Layout } from '../components/Layout';

import FeedbackChart from '@/components/FeedbackChart';

export const DashboardPage: React.FC = () => {
  return (
    <Layout sidebar={true}>
      <div className="flex flex-col h-full overflow-hidden px-4 sm:px-6 lg:px-8">
        <div className="p-6 space-y-6">
          <FeedbackChart />
        </div>
      </div>
    </Layout>
  );
};
